/* ==========================================================================
   Carga limpia — reveal sin parpadeo + skeleton shimmer de imágenes
   Independiente de GSAP. Se carga con defer (DOM ya parseado y con layout).
   ========================================================================== */
(function () {
  'use strict';

  var docEl = document.documentElement;
  /* .reveal-ready lo pone el script inline del <head> salvo reduced-motion.
     Si no está, no ocultamos nada: todo se ve normal. */
  var REVEAL_ON = docEl.classList.contains('reveal-ready');
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ======================================================================
     FIX 1 — Scroll reveal (dirigido por CSS, sin flash)
     Observamos el CONTENEDOR [data-reveal] y revelamos TODOS sus items a la
     vez (igual que hacía el GSAP original). Así las copias off-screen de los
     carruseles nunca quedan atascadas invisibles.
     ====================================================================== */
  function revealTargets(container) {
    var items = container.querySelectorAll('[data-reveal-item]');
    return items.length ? items : [container];
  }

  function reveal(container) {
    var targets = revealTargets(container);
    var stagger = targets.length > 1;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t.classList.contains('is-revealed')) continue;
      if (stagger) {
        var d = i * 0.08;
        t.style.transitionDelay = (d > 0.4 ? 0.4 : d) + 's';
      }
      t.classList.add('is-revealed');
    }
  }

  function initReveal() {
    var containers = document.querySelectorAll('[data-reveal]');
    if (!containers.length) return;

    /* reduced-motion / sin .reveal-ready / sin IO → todo visible ya */
    if (!REVEAL_ON || !('IntersectionObserver' in window)) {
      for (var i = 0; i < containers.length; i++) reveal(containers[i]);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var e = 0; e < entries.length; e++) {
        if (entries[e].isIntersecting) {
          reveal(entries[e].target);
          obs.unobserve(entries[e].target);
        }
      }
    }, { root: null, rootMargin: '0px 0px -15% 0px', threshold: 0 });

    for (var j = 0; j < containers.length; j++) io.observe(containers[j]);

    /* Failsafe robusto: revela TODOS los contenedores que sigan ocultos —también
       los de debajo del pliegue— en cuanto la página termina de cargar (evento
       'load', tras las imágenes). Así el contenido nunca queda invisible sin
       scroll (IntersectionObserver que falle, cargas muy rápidas o capturas de
       página completa). El scroll-reveal anima lo que aparezca antes. */
    function revealAll() {
      for (var k = 0; k < containers.length; k++) {
        var c = containers[k];
        var targets = c.querySelectorAll('[data-reveal-item]');
        if (!targets.length) targets = [c];
        for (var t = 0; t < targets.length; t++) {
          /* Sin transición: salto directo a visible (el scroll-reveal ya animó
             lo de arriba; esto garantiza que el resto quede fijo y visible). */
          targets[t].style.transition = 'none';
          targets[t].style.transitionDelay = '0s';
          targets[t].classList.add('is-revealed');
        }
        io.unobserve(c);
      }
    }
    if (document.readyState === 'complete') {
      setTimeout(revealAll, 100);
    } else {
      window.addEventListener('load', function () { setTimeout(revealAll, 100); });
    }
    setTimeout(revealAll, 1200);
  }

  /* ======================================================================
     FIX 2 — Skeleton shimmer de imágenes (global)
     ====================================================================== */
  /* No tocar imágenes del hero (LCP + su propio lazy con data-src). */
  var HERO_SEL = '[data-hs], [data-hero-slider], [data-hero]';

  function finishSkeleton(img, host) {
    img.classList.add('skel-loaded');
    var cleanup = function () {
      img.classList.remove('skel-img', 'skel-loaded');
      img.style.transitionDelay = '';
      if (host) host.classList.remove('skel-host');
    };
    /* fade .4s → limpiamos después; instantáneo con reduced-motion */
    if (reduceMotion) { cleanup(); return; }
    setTimeout(cleanup, 450);
  }

  function processImg(img) {
    if (img.dataset.skel) return; /* idempotente */

    /* Sin src (p.ej. hero con data-src): lo maneja su propio JS/nativo. */
    if (!img.getAttribute('src')) return;

    /* LCP: no meter skeleton en imágenes prioritarias ni del hero. */
    if (img.getAttribute('loading') === 'eager') { img.dataset.skel = '1'; return; }
    if (img.getAttribute('fetchpriority') === 'high') { img.dataset.skel = '1'; return; }
    if (img.closest && img.closest(HERO_SEL)) { img.dataset.skel = '1'; return; }

    /* Necesita una caja con dimensión (ratio box) para no romper el layout;
       de paso descarta iconos pequeños. Si aún no tiene caja, se salta sin
       marcar (podría procesarse más tarde vía observer). */
    if (img.offsetWidth < 48 || img.offsetHeight < 48) return;

    /* El shimmer se pinta en el PADRE (skel-host). Solo aplicamos si la img
       llena (casi) su contenedor; si es una img pequeña dentro de una caja
       grande (p.ej. un logo centrado), el shimmer se vería mayor que la foto. */
    var host = img.parentElement;
    if (!host) return;
    var hb = host.getBoundingClientRect();
    if (hb.width && hb.height) {
      if (img.offsetWidth < hb.width * 0.9 || img.offsetHeight < hb.height * 0.9) {
        img.dataset.skel = '1';
        return;
      }
    }

    /* Ya cargada (caché): visible ya, sin skeleton (no provocar flash). */
    if (img.complete && img.naturalWidth > 0) { img.dataset.skel = '1'; return; }

    img.dataset.skel = '1';
    host.classList.add('skel-host');
    img.classList.add('skel-img');

    var done = function () { finishSkeleton(img, host); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    /* Carrera: pudo terminar entre las comprobaciones y el addEventListener. */
    if (img.complete && img.naturalWidth > 0) done();
  }

  function processImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) processImg(imgs[i]);
  }

  /* Imágenes inyectadas después (carruseles infinite, apps tipo Loox…). */
  function initImgObserver() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var a = 0; a < added.length; a++) {
          var node = added[a];
          if (!node || node.nodeType !== 1) continue; /* solo elementos */
          if (node.tagName === 'IMG') {
            processImg(node);
          } else if (node.querySelectorAll) {
            var imgs = node.querySelectorAll('img');
            for (var i = 0; i < imgs.length; i++) processImg(imgs[i]);
          }
        }
      }
    });
    try {
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* noop */ }
  }

  /* Failsafe skeleton: a los 2.5s, cualquier img aún oculta → mostrar. */
  function skeletonFailsafe() {
    setTimeout(function () {
      var stuck = document.querySelectorAll('img.skel-img:not(.skel-loaded)');
      for (var i = 0; i < stuck.length; i++) {
        finishSkeleton(stuck[i], stuck[i].parentElement);
      }
    }, 2500);
  }

  /* ====================================================================== */
  function boot() {
    try { initReveal(); } catch (e) { /* noop */ }
    try {
      processImages(document);
      initImgObserver();
      skeletonFailsafe();
    } catch (e) { /* noop */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
